import { render, staticRenderFns } from "./LatestPlanupMultiMessages.vue?vue&type=template&id=48130506"
import script from "./LatestPlanupMultiMessages.vue?vue&type=script&lang=js"
export * from "./LatestPlanupMultiMessages.vue?vue&type=script&lang=js"
import style0 from "./LatestPlanupMultiMessages.vue?vue&type=style&index=0&id=48130506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports